module.exports = __webpack_public_path__ + "static/img/yytx06.9b90159.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx06.png
// module id = 786
// module chunks = 0